import vars from "../helpers";
import sliceText from '../components/slice-text';
const init = () => {
	const $news = vars.$document.find('.news');
	const newsItem = $news.find('.news__item');
	const newsButton = $news.find('.news__button');
	let text = $news.find('.news__text');
	sliceText.init(text, 420);

	if($news.length) {
		if (newsItem.length > 4) {
			newsButton.removeClass('is-hidden');
			$news.find('.news__item:nth-child(n+5)').addClass('is-hidden')
		}

		const openNews = () => {
			$news.find('.news__item:nth-child(n+5)').slideDown('1000').css('display', 'flex').removeClass('is-hidden');
			newsButton.fadeOut();
		};

		newsButton.on('click', openNews)
	}
};

export default {
	init,
}
